module.exports = __webpack_public_path__ + "img/maestro.76938089.svg";